import { Alert, Snackbar, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "../app/slices/commonSlice";

const GeneralLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { snackbar } = useSelector(({ common }) => common);
  return (
    <>
      <div>{children}</div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.timeout}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          dispatch(hideSnackbar());
        }}
      >
        <Alert
          onClose={() => {
            dispatch(hideSnackbar());
          }}
          severity={snackbar.type}
        >
          <Typography className="snackbar-text">{snackbar.message}</Typography>
        </Alert>
      </Snackbar>
    </>
  );
};

export default GeneralLayout;
